import { useCallback, useContext } from "react";
import { useQuery } from "react-query";

import { UseQueryProps } from "../../interfaces";
import { apiServiceContext } from "../../api-service-context";
import { QueryKeys } from "../query-keys";
import { IFetchCommentsOfParkingArealParams } from "../domain";

export const useCommentsOfParkingAreal = <TData = any, TError = any>(
  params: IFetchCommentsOfParkingArealParams,
  queryOptions: UseQueryProps<TData, TError> = {}
) => {
  const { publicApiService } = useContext(apiServiceContext);
  const queryFn = useCallback(
    () =>
      publicApiService.createCancellableRequest((cancelToken) =>
        publicApiService.getCommentsOfParkingAreal(params, cancelToken)
      ),
    [publicApiService, params]
  );

  return useQuery(QueryKeys.commentsOfParkingAreal(params), queryFn, queryOptions);
};
